import React from 'react';
import Fab from '@mui/material/Fab';
import withStyles from '@mui/styles/withStyles';
import { joinDefined, stringIsNullOrEmpty } from '../../utils/strings';
import { CloseIcon, TickIcon } from '../IconIndex';
import { isNullOrUndefined } from '../../utils/objects';

export default withStyles({})(({ variant, product, image, productTitle, productCost, selectedID, onSelect }) => {
    let cssVariant = null;
    if (!stringIsNullOrEmpty(variant)) cssVariant = `image--${variant}`;
    const isTicked = product && selectedID === product.ID;
    return (
        <div className={joinDefined(['image', cssVariant, isTicked ? 'check' : ''], ' ')}>
            <Fab
                size="small"
                color="primary"
                aria-label="Check"
                className={isTicked ? 'fab check' : 'fab'}
                title={isTicked ? 'Item is selected' : 'Item is not selected'}
                onClick={() => onSelect(product)}
            >
                {isTicked ? <TickIcon /> : <CloseIcon />}
            </Fab>
            <div className="product-thumbnail">
                {!!image && <div className="product-image" style={{ backgroundImage: `url(${image}` }} />}
                {!isNullOrUndefined(productTitle) && (
                    <div className="card-title">
                        <p>{productTitle}</p>
                    </div>
                )}
            </div>
            {!isNullOrUndefined(productCost) && (
                <div className="product-cost">
                    <p>Cost:&nbsp;${productCost}</p>
                </div>
            )}
        </div>
    );
});
